import * as React from 'react'

/**
 * @description Bank icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Bank } from '@sravni/design-system-icons'
 *
 * <Bank />
 * ```
 */
export const Bank = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Bank" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.285 15V7.143M15.714 7.143V15M7.143 7.143V15M10 7.143V15M12.856 7.143V15M17.857 6.143a1 1 0 0 1-1 1H3.143a1 1 0 0 1-1-1V4.63L10 1.429l7.857 3.2v1.514ZM16.928 15.714H3.071l-.928 1.429v.428a1 1 0 0 0 1 1h13.714a1 1 0 0 0 1-1v-.428l-.929-1.429Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
